import { FC } from 'react';
import { Submenu } from './SubMenu.styled';

export const SubMenu: FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Submenu>{children}</Submenu>;
};

export default SubMenu;
